import api from '@/api';
import localConfig from '@/config';
import { normalizeParamsObject } from 'shared-lib/helpers/formatters';
import { separateAlternativeModels } from '@/helpers/filters';

const types = {
    SAVE_FILTERS: 'SAVE_TRIGGERS_FILTERS',
    RESET_FILTERS: 'RESET_TRIGGERS_FILTERS',
    RECEIVE_LIST: 'RECEIVE_TRIGGERS',
    RECEIVE_DETAILS: 'RECEIVE_TRIGGER',
    RECEIVE_TRIGGER_CAMPAIGNS: 'RECEIVE_TRIGGER_CAMPAIGNS',
};

const initialState = {
    data: {
        data: [],
        meta: {},
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-created',
            filter_results_local: 1,
        },
    },
    trigger: {},
    campaigns: {},
};

const state = {
    ...initialState,
};


const getters = {
    triggersData: state => state.data,
    triggerById: state => id => {
        const trigger = state.trigger[id];
        return trigger || {};
    },
    triggerByIdCampaigns: state => id => {
        const campaigns = state.campaigns[id];
        return campaigns || { data: [] };
    },
};


const actions = {
    saveTriggersFilters ({ commit }, payload) {
        commit(types.SAVE_FILTERS, { payload });
    },
    resetTriggersFilters ({ commit }) {
        commit(types.RESET_FILTERS);
    },
    getTriggers ({ commit, state }, payload) {
        const apiFilters = separateAlternativeModels(state.data.filters, payload.fields, payload?.to_remove);
        return api.triggers.list(apiFilters).then((response) => {
            commit(types.RECEIVE_LIST, { response });
        });
    },
    getTrigger ({ commit }, id) {
        return api.triggers.get(id).then((response) => {
            commit(types.RECEIVE_DETAILS, response.data);
        });
    },
    addTrigger (store, data) {
        return api.triggers.create(data);
    },
    cloneTrigger (store, data) {
        return api.triggers.create(data);
    },
    editTrigger (store, payload) {
        return api.triggers.update(payload.id, payload);
    },
    getTriggerCampaigns ({ commit }, { id, params }) {
        return api.triggers.campaigns(id, params).then((response) => {
            response.data.id = id;
            commit(types.RECEIVE_TRIGGER_CAMPAIGNS, response.data);
        });
    },
};


const mutations = {
    [types.SAVE_FILTERS] (state, { payload }) {
        let payloadNormalized = normalizeParamsObject(payload);
        state.data = {
            ...state.data,
            filters: { ...payloadNormalized },
        };
    },
    [types.RECEIVE_LIST] (state, { response }) {
        state.data = { ...state.data, ...response.data };
    },
    [types.RECEIVE_DETAILS] (state, { data }) {
        if (data && data.id) {
            state.trigger[data.id] = data;
            state.trigger = Object.assign({}, state.trigger);
        }
    },
    [types.RECEIVE_TRIGGER_CAMPAIGNS] (state, { data, meta, id }) {
        if (data && id) {
            state.campaigns[id] = { data, meta };
            state.campaigns = Object.assign({}, state.campaigns);
        }
    },
    [types.RESET_FILTERS] (state) {
        state.data.filters = { ...initialState.data.filters };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
